import { useQuery } from '@tanstack/react-query';
import { queryKeys, accountsService } from '@v2/services';

export const useAccounts = () => {
  const query = useQuery({
    queryKey: queryKeys.accounts.lists(),
    queryFn: accountsService.getAccounts,
  });

  return {
    accounts: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useAccounts;
